export const FEATURE_FLAG_REVIEW_PROJECTS = "review-projects"
